"use strict";

import Global from "/js/core/global.js";
import FadeUtil from "/js/util/fade-util.js";
import PrimerMaster from "/js/util/primermaster.js";
import AppUtil from "/js/util/app-util.js";

/** 
 * Lesson progress bar.
 */
export default class BarView {

  #$el;
  #$fill;

  #numCards;

  constructor() {
    this.#$el = $("#bar");
    this.#$fill = this.#$el.find("#barFg");
 }

  get $el() {
    return this.#$el;
  }

  show() {
    this.#$fill.removeClass();
    const cls = PrimerMaster.getBgDarkColorClassForLessonId(Global.lessonId);
    this.#$fill.addClass(cls);

    this.#$el.show();
    FadeUtil.fadeIn(this.#$el);
  }

  set numCards(i) {
    this.#numCards = i;
  }

  hide() {
    FadeUtil.fadeOut(this.#$el);
  }

  update(cardIndex, now=false) {
    const percentString = (cardIndex / this.#numCards * 100) + "%";
    const doUpdate = () => this.#$fill.width(percentString);
    now ? AppUtil.setCssWithoutTransition(this.#$fill, doUpdate) : doUpdate();
  }
}